import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { BankDetails, DeliverService, DeliverServicesClient, NServices, ServiceClient } from "src/app/web-api-client";

@Component({
  selector: 'app-deliverService-edit',
  templateUrl: './deliverService-edit.component.html',
  styleUrls: ['./deliverService-edit.component.scss']
})
export class DeliverServiceEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: DeliverService;
  public services: NServices[];
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  // ServiceTermType options for dropdown
  serviceTermTypes = [
    { value: 0, label: 'Неизвестен (Unknown)' },
    { value: 1, label: 'Експресна услуга (Express)' },
    { value: 2, label: 'Бърза услуга (Fast)' },
    { value: 3, label: 'Обикновена услуга (Standard)' }
  ];

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public client: DeliverServicesClient, public serviceClient: ServiceClient) { }

  ngOnInit(): void {
    this.serviceClient.getList().subscribe(services => {

      this.services = services;
      this.initializeForm();
      this.isLoaded = true;

    })
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: [this.editObject.title, Validators.required],
      deliverTaxe: [this.editObject.deliverTaxe, Validators.required],
      service: [this.editObject.idService, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
      staticTax: [this.editObject.staticTax || false],
      serviceTermTypeId: [this.editObject.serviceTermTypeId || 0],
      sample: [this.editObject.sample || '']
    });

    // Set up two-way binding between deliverTaxe and staticTax
    this.setupTaxBindings();
  }

  private setupTaxBindings() {
    // When deliverTaxe changes, update staticTax
    this.Form.get('deliverTaxe')?.valueChanges.subscribe(value => {
      const taxAmount = parseFloat(value);
      if (!isNaN(taxAmount) && taxAmount > 0) {
        this.Form.get('staticTax')?.setValue(true, { emitEvent: false });
      }
    });

    // When staticTax is unchecked, set deliverTaxe to 0
    this.Form.get('staticTax')?.valueChanges.subscribe(value => {
      if (value === false) {
        this.Form.get('deliverTaxe')?.setValue(0, { emitEvent: false });
      }
    });
  }

  onSubmit() {
    if (this.Form.valid) {

      this.editObject.title = this.Form.value.title;
      // Convert deliverTaxe to number to ensure proper serialization
      this.editObject.deliverTaxe = +this.Form.value.deliverTaxe;
      this.editObject.idService = this.Form.value.service;
      this.editObject.service = null;
      // Preserve idBankDetails - it's set either from the original object or from onBankAccountSelected
      // Only null out the navigation property to avoid circular reference issues
      this.editObject.bankDetails = null;
      this.editObject.serviceProvider = null;
      this.editObject.isActive = this.Form.value.isActive;
      this.editObject.staticTax = this.Form.value.staticTax;
      this.editObject.serviceTermTypeId = +this.Form.value.serviceTermTypeId;
      this.editObject.sample = this.Form.value.sample || null;

      this.client.update(this.editObject).subscribe(
        (result) => {
          if (result) {
            this.onClose.next(true);
            this.activeModal.close();
          } else {
            alert('Грешка при запазване. Моля, проверете правата си за достъп.');
          }
        },
        (error) => {
          alert('Грешка при запазване: ' + (error.message || 'Неизвестна грешка'));
        }
      );
    }
  }

  public isSelected(service:NServices) {
    let result = this.editObject.idService == service.idService;
    return result;
  }

  onBankAccountSelected(bankAccount:BankDetails) {
    this.editObject.idBankDetails = bankAccount.idBankDetails;
  }

  closeModal() {
    this.activeModal.close();
  }

}
